import { z } from "@ipis/centralized-zod";

const WeekDayTupleSchema = z.tuple([
  z.boolean(),
  z.boolean(),
  z.boolean(),
  z.boolean(),
  z.boolean(),
  z.boolean(),
  z.boolean(),
]);
export type WeekDayTupleType = z.infer<typeof WeekDayTupleSchema>;

const CommonFields = z.object({
  address: z.object({
    name: z.string().min(1),
    latitude: z.number(),
    longitude: z.number(),
  }),
  qualification: z.string().min(1),
});

const OriginalFlowShema = CommonFields.extend({
  type: z.literal("original"),
  timeEstimateInMinutes: z.union([
    z.string().min(1).transform(Number),
    z.number().min(1),
  ]),

  week: z.union([z.string().min(1).transform(Number), z.number().min(1)]),
  weekDays: WeekDayTupleSchema.refine((val) => {
    return Array.from(val).some((v) => v);
  }),
});

const SimplifiedFlowSchema = CommonFields.extend({
  type: z.literal("simplified"),
});

export const BookingSuggestionsFormSchema = z.union([
  OriginalFlowShema,
  SimplifiedFlowSchema,
]);
export type BookingSuggestionsFormValues = z.infer<
  typeof BookingSuggestionsFormSchema
>;
